import { formatDate } from './format-date';
import { formatTime } from './format-time';

export function formatDateTime(timestamp: Date | string | number): string {
  return `${formatDate(timestamp)} - ${formatTime(timestamp)}`;
}
